<template>
  <searchpage pageName="Loans" :filters="filters"></searchpage>
</template>

<script setup>
  import { ref, onMounted } from "vue";
  import searchpage from "@/components/layout/SearchPage.vue";
  import axios from "axios";

  const filters = ref([
    {
			description: 'Type',
			param: 'ProductTypeIds',
			type: 'radio',
			results: [
				{
                    id: 'skip', // wtf why
					name: 'All',
					checked: true
				},
				{
					id: 1,
					name: 'Line of Credit (LOC)',
					checked: false
				},
				{
					id: 2,
					name: 'Refinance',
					checked: false
				},
				{
					id: 3,
					name: 'Private Education Loan (PEL)',
					checked: false
				}
			]
		},
    {
      description: "Status",
      param: "StatusIds",
      results: [
        {
          name: "Active",
          id: 1,
          checked: false,
          param: "StatusIds",
        },
        {
          name: "Inactive",
          id: 2,
          checked: false,
          param: "StatusIds",
        },
      ],
    },
	{
      description: "Annual Review Filters",
      param: "AnnualReviewStatusIds",      
      results: [
	      {
          name: "Batched",
          id: 1,
          checked: false,
          param: "AnnualReviewStatusIds",        
        },
        {
          name: "Decision Error",
          id: 3,
          checked: false,
          param: "AnnualReviewStatusIds",           
        },
	    	{
          name: "AR Credit Alert",
          id: 4,
          checked: false, 
          param: "AnnualReviewStatusIds",          
        }, 
	    	{
          name: "Initially Passed",
          id: 5,
          checked: false, 
          param: "AnnualReviewStatusIds",          
        }, 
		    {
          name: "Initially Failed",
          id: 6,
          checked: false,
          param: "AnnualReviewStatusIds",           
        }, 
		    {
          name: "AR Approved",
          id: 7,
          checked: false, 
          param: "AnnualReviewStatusIds",          
        }, 
		    {
          name: "AR Declined",
          id: 8,
          checked: false,
          param: "AnnualReviewStatusIds",           
        }, 
      ],
    },
  ]);

  const fetchYears = async () => {
    try {
      const response = await axios.get(`/api/LoanService/annualreview/years`);
      const arYears = response.data;

      if (Array.isArray(arYears) && arYears.length > 0) {
        filters.value.push({
          description: "Annual Review Year:",
          param: "AnnualReviewYear",
          type: "dropdown",
          checked: false,
          results: [
              { id: "skip", name: "Choose a Year" },
              ...arYears.map((year) => ({
                  id: year,
                  name: year.toString()
              }))
          ],
        });
      }
    } catch (error) {
      console.error("Error fetching annual review years:", error);
    }
  };

  // Fetch data before passing filters
  onMounted(() => {
    fetchYears();
  });
</script>